import { Component, EventEmitter, Input, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-left-panel',
    templateUrl: './left-panel.component.html',
    styleUrls: ['./left-panel.component.scss'],
    imports: [TranslateModule],
})
export class LeftPanelComponent {
    @Input() communityDisplayName: string;

    @Output() closeClick: EventEmitter<any> = new EventEmitter();

    close() {
        this.closeClick.emit();
    }
}
